import { createClient } from "@supabase/supabase-js";
import { storage } from "./utils/storage";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // Log clearly in console but don't throw at module level — a synchronous
  // throw here happens before React mounts and silently produces a white screen
  // because the ErrorBoundary in main.jsx never gets a chance to run.
  console.error(
    "[orbit] Missing Supabase env vars. Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY."
  );
}

// On native, `storage` persists the Supabase session tokens via
// @capacitor/preferences (iOS UserDefaults / Android SharedPreferences) in the
// app's sandboxed container, keeping them out of WKWebView localStorage.
// On web it uses localStorage. See src/utils/storage.js for details.
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

